import ApolloClient from "apollo-client";
import gql from "graphql-tag";
import { analytics } from "../analytics";

export const USER_IDENTIFICATION_QUERY = gql`
  query userIdentificationQuery {
    user: me {
      id
      email
      intercomIdentity
    }
  }
`;

export const watchUserIdentification = (apolloClient: ApolloClient<any>) => {
  return apolloClient
    .watchQuery({
      query: USER_IDENTIFICATION_QUERY,
      // NOTE: This means it won't identify until another query sets the user in the cache
      fetchPolicy: "cache-only",
    })
    .subscribe({
      next: (data) => {
        const user = data?.data.user;

        if (user) {
          analytics.identifyUser(user);
        }
      },
    });
  // NOTE: We're not unsubscribing from the query, which could cause duplication in staging
};
